import gql from 'graphql-tag';

export default gql`
    query GetSelectedDriversForJob($jobId: Int) {
        getSelectedDriversForJob(jobId: $jobId) {
            id
            driverId
            name
            companyName
            jobName
            notes
        }
    }
`;
